export var getMemberExtraClassNames = function (extraOptions) {
    switch (extraOptions) {
        case "hideOnDesktop":
            return "md:hidden";
        case "hideOnMobile":
            return "hidden md:block";
        default:
            return;
    }
};
//# sourceMappingURL=getMemberExtraClassNames.js.map